module.exports = __webpack_public_path__ + "images/help/video-preview-newtodo-0db68decaca80fec1e17248756e14718.jpg";